import { QueryObserverOptions, useQuery } from 'react-query';

import axiosClient from '@lib/utils/axiosClient';

import { ManyEndpointPostfix, Params, ResourceKeys } from '../types';

async function fetchEntityMany<EntityName extends string, EntityMany>(
  entity: EntityName,
  params: Params,
  postFix: ManyEndpointPostfix,
) {
  const response = await axiosClient.get<EntityMany>(`/${entity}${postFix}`, { params });
  return response.data;
}

export function useEntityMany<EntityMany>(
  keys: ResourceKeys['many'],
  postFix: ManyEndpointPostfix,
  params: Params,
  options?: QueryObserverOptions<EntityMany>,
) {
  const entityKeys = keys({ ...params, url: postFix });
  const [entityName] = entityKeys;
  return useQuery<EntityMany>(entityKeys, () => fetchEntityMany(entityName, params, postFix), options);
}
